import { ReactNode } from 'react';
import { FormApi } from 'final-form';
import { IApiResponse } from 'utils/models';

export const sortArrays = ['Source Account:', 'Destination Account:', 'Narration:', 'Amount:'];

export const bulkDataConfig = {
  sourceAccount: 'Source Account:',
  numberOfTransactions: 'Number of Transactions:',
  totalTransactionAmount: 'Total Transaction Amount:',
  totalAmount: 'Total Amount:',
  transactionCharge: 'Transaction Charge:',
  frequency: 'Frequency:',
  startDate: 'Special Date:',
};

export const bulkSortArray = [
  'Source Account:',
  'Number of Transactions:',
  'Total Transaction Amount:',
  'Transaction Charge:',
  'Total Amount:',
  'Frequency:',
  'Special Date:',
];

export type FormType = FormApi<IFormValues, Partial<IFormValues>>;

export const warnings = {
  MAX_BULK_TRANSFERS: 'You have reached the maximum(10) number of transfers.',
  SAME_ACCOUNT: 'The destination account should not be same as source account.',
  ACCOUNT_NOT_VERIFIED: 'The destination account was not verified.',
  ENTER_NON_INSTANT_BEN: 'You should enter the beneficiary name.',
};

export const FAB_BANK = { code: '300316', name: 'First Atlantic Bank' };

export interface IExtraFields {
  destinationBankName: string;
  destinationBankCode: string;
  destinationAccountName: string;
  destinationIsExistingBen: boolean;
  beneficiaryId?: number;
  charge?: number;
}

export interface IFormValues {
  sourceAccount: string;
  amount: string;
  destinationAccountNo: string;
  narration: string;
  pin?: string;
  scheduleTransfer?: boolean;
  files: fileUpload[];
  frequency: string;
  startDate: string
}

type fileUpload = {
  name: string;
  size: number;
}

export interface ITransactionField {
  label: ReactNode;
  value: ReactNode;
}

export type BankTypeKeys = 'INSTANT' | 'NON_INSTANT';

export interface IFormCommonFields {
  sourceAccount: string;
  amount: number | string;
  destinationAccountNo: string;
  narration: string;
  destinationBankCode: string;
}

export interface IBulkCommonFields extends IFormCommonFields, IExtraFields {
  currencyCode: string;
  saveBen: boolean;
  transferType?: BankTypeKeys;
}

export interface IBulkTransferData {
  Amount: number | string;
  DestinationAccountNo: string;
  Narration: string;
  DestinationBankCode: string;
  DestinationAccountName: string;
  CurrencyCode: string;
  SaveBen: boolean;
}

export interface ITransferResponse extends IApiResponse {
  transactionId: number;
}
export interface IBulkUploadData extends IApiResponse {
  bulkUploadData: IBulkDataList[]
}

export interface IBulkDataList {
  createdDate: string,
  transactionAmount: number,
  transactionType: string,
  transactionNarration: string,
  beneficiaryAccount: string,
  beneficiaryName: string,
  beneficiaryBank: string,
  beneficiaryBankCode: string,
  bankBranch: string
  transactionDescription: string,
  sourceAccount: string,
  code: number,
  charge: number,
  description: string,
  beneficiaryId: number | string
}

export interface IBulkTransferBody {
  sourceAccount: string;
  sourceAccountType: string;
  passwordType: string;
  password: string;
  bulkTransferData: IBulkTransferData[] | string;
}

export type IBulkStatusModalP = {
  open: boolean;
  status: 'success' | 'failure';
  content: React.ReactChild;
}

export interface IBulkCardData
  extends Pick<
    IBulkCommonFields,
    'amount' | 'destinationAccountNo' | 'sourceAccount' | 'narration' | 'destinationAccountName' | 'transferType'
  > {
  destinationBankName?: string;
  transactionCharge?: string | number;
}
